import {
  eolsBaseApi,
  withApiErrorLoggingOnly
} from '../../utilities/api.utilities';
import {
  AppLinkData
} from './eols-app-link.dtos';
import {
  Application
} from './eols-app-link.constants';
import {
  AppLinkOutConfig,
  AppLinkOutResponse
} from './eols-app-link.models';
import { addSearchParams, clientTimeZone } from '../../utilities/app.utilities';

export const getAppLinkApiUrl = (config: AppLinkOutConfig): string => {
  const {
    app,
    action
  } = config;
  if (app === Application.EPM_SKILL) {
    return `/sherpath/course-management/skill/app-link/${action}`;
  }
  const queryParams = {
    linkId: config.linkId,
    includeLinkHash: config.includeLinkHash,
    isCrossDomain: config.isCrossDomain,
    altSrcApp: config.altSrcApp,
    parentLinkId: config.parentLinkId
  };
  return addSearchParams(`/app-link/out/${app}/${action}`, queryParams);
};

export const getExternalAppRedirectUrl = (
  config: AppLinkOutConfig,
  token?: string
): Promise<AppLinkOutResponse> => {

  const headers = token ? {
    Authorization: `Bearer ${token}`
  } : {};

  const body = config.app === Application.SHADOW_HEALTH
    ? { ...config.body, timezone: clientTimeZone }
    : config.body;

  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.post<AppLinkOutResponse>(
      getAppLinkApiUrl(config),
      {
        ignoreToken: true,
        data: body
      },
      headers
    );
  });
};

export const getLinkNavigation = (props: {
  linkId: string;
  assignmentIds: number[];
}): Promise<AppLinkOutResponse> => {
  const {
    linkId,
    assignmentIds
  } = props;
  return withApiErrorLoggingOnly(() => {
    const returnPostBody = assignmentIds && assignmentIds.length ? {
      assignmentIds
    } : null;
    const options = returnPostBody ? { data: returnPostBody } : null;
    return eolsBaseApi.post<AppLinkOutResponse>(`/app-link/return/${linkId}`, options);
  });
};

export type HashLinkDto = {
  token: string;
  linkId: string;
}

export const fetchHashLink = (hashLink: string): Promise<HashLinkDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get<HashLinkDto>(`/app-link/hash-link/${hashLink}`, {
      headers: {
        'X-App-ID': Application.ASSIGNMENT_MANAGEMENT
      }
    });
  });
};

export const fetchAppLinkData = (key: string): Promise<AppLinkData> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get<AppLinkData>(`/app-link/data/${key}`);
  });
};
